import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon47: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#FFD147"
        d="M8 0a2.5 2.5 0 0 1 2.5 2.5v1.059c2.081.994 3.5 3.204 3.5 5.677v3.098l1.7 2.266c.741.989.036 2.4-1.2 2.4l-3.035.001a3.5 3.5 0 0 1-6.93 0L1.5 17C.264 17-.44 15.589.3 14.6L2 12.334V9a5.994 5.994 0 0 1 3.5-5.455V2.5A2.5 2.5 0 0 1 8 0Zm2.45 17h-4.9a2.501 2.501 0 0 0 4.9 0ZM8.493 4.023A5.002 5.002 0 0 0 3 9v3.5a.497.497 0 0 1-.1.3l-1.8 2.4a.5.5 0 0 0 .4.8h13a.5.5 0 0 0 .4-.8l-1.8-2.4a.497.497 0 0 1-.1-.3V9.236c0-2.672-1.96-4.97-4.507-5.213ZM8 1a1.5 1.5 0 0 0-1.5 1.5v.689c.66-.17 1.363-.23 2.088-.161.312.029.617.085.912.163V2.5A1.5 1.5 0 0 0 8 1Z"
      />
    </Svg>
  )
}
